import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    CatGoriesDArticlesJsonldCategorieArticleRead,
    CatgoriesDarticlesApi,
} from '../../../openApi/ApiOffre';
import { ARTICLES_CATEGORIES_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type ArticleCategoryApiObject = CatGoriesDArticlesJsonldCategorieArticleRead &
    Record<string, unknown>;

export type ArticlesCategories = ArticleCategoryApiObject;

const mapperArticlesCategories = function (articles: ArticleCategoryApiObject) {
    return {
        ...articles,
    } as ArticlesCategories;
};

export function createArticlesCategoriesSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new CatgoriesDarticlesApi(conf);

    const fetchArticlesCategoriesCollection: FetchCollectionData<ArticleCategoryApiObject> = ({
        pagination: { page },
        xIdSociete,
    }) =>
        api
            .apiCategoriesArticlesGetCollection({
                xIdSociete,
                page: page + 1,
                itemsPerPage: 1000,
            })
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<ArticleCategoryApiObject>>;

    const fetchArticlesCategoriesItem: FetchItemDataType<ArticleCategoryApiObject> = ({
        idItem,
        xIdSociete,
    }) =>
        api
            .apiCategoriesArticlesIdGet({
                id: String(idItem),
                xIdSociete,
            })
            .then((res) => res.data) as Promise<ArticleCategoryApiObject>;

    const {
        slice: articlesCategoriesSlice,
        dataSourcesThunks: articlesCategoriesDataSourcesThunks,
    } = SliceFactory.createSlice<ArticleCategoryApiObject, ArticlesCategories>(
        ARTICLES_CATEGORIES_SLICE_NAME,
        OFFRE_REDUCER_NAME,
        [],
        fetchArticlesCategoriesCollection,
        fetchArticlesCategoriesItem,
        mapperArticlesCategories,
    );

    return { articlesCategoriesSlice, articlesCategoriesDataSourcesThunks };
}
